/**
 * Appendix I names no base curve or diameter rule. These are the bounds
 * `cl_prescription_eye_base_curve_range` and `cl_prescription_eye_diameter_range` already hold in
 * the tenant schema, restated here so a write is refused as a sentence before it reaches a check
 * constraint (a `PostgresError` is a 500, which a write queue retries forever).
 */
export const CONTACT_LENS_BASE_CURVE_MM = { min: 7, max: 10.5, decimals: 2 };
export const CONTACT_LENS_DIAMETER_MM = { min: 12, max: 16, decimals: 1 };
/**
 * Why a millimetre value is not storable, or `null` when it is. `decimals` is the case a range check
 * cannot see: 8.555 is in range and would be stored as 8.56, a lens nobody ordered.
 */
export function millimetreProblem(value, bounds) {
    if (!Number.isFinite(value) || value < bounds.min || value > bounds.max)
        return 'range';
    const scaled = value * 10 ** bounds.decimals;
    return Math.abs(scaled - Math.round(scaled)) > 1e-9 ? 'decimals' : null;
}
//# sourceMappingURL=contact-lens.js.map